const errorMessages: { [key: string]: string } = {};
export default errorMessages;
